<template>
  <div class="problem-title">
    <div v-if="!isEdit" class="problem-title__content">
      <a-tooltip placement="top" :title="value">
        <a class="problem-title__link" :href="link" target="_blank">{{ value }}</a>
      </a-tooltip>
      <a-icon v-if="permission" class="problem-title__edit-icon" type="edit" @click="onEdit" />
    </div>
    <a-input v-else ref="title" v-model="value" size="small" class="problem-title__input" :max-length="100" @blur="onBlur" @pressEnter="onBlur" />
  </div>
</template>

<script>
import { problemUpdateItem } from '@/api/event/problem';

export default {
  name: 'ProblemTitleEdit',
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    sourceValue: {
      type: String,
      default: null
    },
    isFault: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: null,
      isEdit: false
    };
  },
  computed: {
    permission() {
      return true;
    },
    link() {
      const route = this.$router.resolve({
        name: 'page:event:problem:detail',
        query: { problemId: this.sourceId }
      });
      return route.href;
    }
  },
  watch: {
    sourceValue: {
      handler(newVal) {
        this.value = newVal;
      },
      immediate: true
    }
  },
  methods: {
    onEdit() {
      this.isEdit = true;
      this.$nextTick(() => {
        this.$refs.title.focus();
      });
    },
    onViewFault() {
      this.$router.push({
        name: 'page:event:fault:detail',
        query: { faultId: this.sourceId }
      });
    },
    onBlur() {
      if (!this.value || this.value === this.sourceValue) {
        this.value = this.sourceValue;
        this.isEdit = false;
        return;
      }

      problemUpdateItem({ id: this.sourceId, item: 'title', value: this.value })
        .then(() => {
          this.isEdit = false;
          this.$message.success('更新成功');
        })
        .catch(res => {
          this.value = this.sourceValue;
          this.isEdit = false;
          this.$message.warning(res.message);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.problem-title {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 8px;

  &__content {
    display: flex;
    align-items: center;
    width: 100%;
    height: 24px;
  }

  &__link {
    display: inline-block;
    color: rgba(0, 0, 0, 0.65);
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.3s;
    margin-right: 24px;

    &:hover {
      color: #1890ff;
    }
  }

  &__edit-icon {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
    opacity: 0;
    transition: all 0.3s;
    line-height: 1;
    padding: 4px;
    margin-left: -20px;

    &:hover {
      color: #1890ff;
    }
  }

  &__content:hover &__edit-icon {
    opacity: 1;
  }

  &__input {
    width: 100%;
  }
}
:deep(.ant-input) {
  resize: none;
  border: none;
  border-radius: 0;
  background-color: transparent;
  border-bottom: 1px solid #1890ff;

  &:hover,
  &:focus {
    border-bottom: 1px solid #1890ff;
  }

  &:focus {
    border: none;
    box-shadow: none;
    border-bottom: 1px solid #1890ff;
  }
}
:deep(.ant-input-sm) {
  padding: 0;
}
</style>
